export const Australia = {
    name: "Australia",
    image: "/Australia.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose Australia for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose Australia for its world-class education system, diverse culture, and excellent post-study work opportunities. The country offers a safe, welcoming environment with high-quality universities and colleges.",
            "Australia's strong economy, multicultural society, and pathways to permanent residency make it an attractive destination for international students seeking quality education and career prospects."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Seven Australian cities rank in the top 50 of the QS Best Student Cities 2024, including Melbourne and Sydney."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "Australia offers up to 4 years of post-study work opportunities through the Temporary Graduate visa."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "Australia has 7 universities in the top 100 of the QS World University Rankings 2024, with 38 universities ranked overall."
        },
        {
            icon: "fas fa-users",
            title: "Multicultural experience",
            description: "Australia's diverse student population provides a rich, multicultural educational experience with students from over 190 countries."
        }
    ],
    keyFacts: [
        { factNumber: "43+", factLabel: "Universities and colleges" },
        { factNumber: "7,50,000", factLabel: "International Students in Australia in 2024" },
        { factNumber: "40 Hours", factLabel: "Per fortnight Part-time work permit" },
        { factNumber: "4 Years", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Canberra",
        poplulation: "26.5 million",
        economicGrowthRate: "2.5%",
        currency: "Australian Dollar (AUD)",
        language: "English",
        weather: [
            "Sydney: 9°C - 18°C",
            "Melbourne: 7°C - 15°C",
            "Brisbane: 10°C - 22°C",
            "Perth: 9°C - 19°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, PTE, CAE)",
        "Statement of Purpose",
        "Letter of Recommendation",
        "Valid passport copy",
        "Proof of finances (Bank statements, GTE statement)",
        "Health insurance (OSHC)",
        "Genuine Temporary Entrant (GTE) statement"
    ],
    intake: {
        title: "Australian universities offer two main intakes, also known as semesters:",
        intakes: [
            {
                name: "Semester 1 (February Intake)",
                month: "Starts in February/March"
            },
            {
                name: "Semester 2 (July Intake)",
                month: "Starts in July/August"
            },
            {
                name: "Summer Semester",
                month: "Starts in November/December (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "Certificate I-IV",
            duration: "6 months - 2 years"
        },
        {
            name: "Diploma",
            duration: "1-2 years"
        },
        {
            name: "Advanced Diploma",
            duration: "1.5-2 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "3-4 years"
        },
        {
            name: "Graduate Certificate",
            duration: "6 months - 1 year"
        },
        {
            name: "Master's Degree",
            duration: "1-2 years"
        }
    ],
    popularPrograms: {
        title: "Australia offers high-quality education across a range of fields. Popular programs for international students include:",
        programs: [
            "Business and Management",
            "Engineering",
            "Information Technology",
            "Health Sciences",
            "Education",
            "Accounting",
            "Nursing",
            "Computer Science",
            "Psychology"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "AUD 15,000 - 25,000",
            bdt: "12,00,000 – 20,00,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "AUD 20,000 - 45,000",
            bdt: "16,00,000 – 36,00,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "AUD 22,000 - 50,000",
            bdt: "17,60,000 – 40,00,000 BDT"
        },
        {
            program: "Doctorate Courses",
            local: "AUD 20,000 to AUD 40,000",
            bdt: "16,00,000 - 32,00,000 BDT"
        },
        {
            program: "MBA Courses",
            local: "AUD 30,000 to AUD 60,000",
            bdt: "24,00,000 - 48,00,000 BDT"
        }
    ],
    topCities: {
        title: "Australia boasts world-class universities in several vibrant cities, offering excellent lifestyle and employment opportunities. Key student cities include:",
        cities: [
            {
                name: "Melbourne",
                description: "Cultural capital with top universities and diverse opportunities"
            },
            {
                name: "Sydney",
                description: "Financial hub with excellent universities and job prospects"
            },
            {
                name: "Brisbane",
                description: "Growing city with affordable living and quality education"
            },
            {
                name: "Perth",
                description: "Beautiful coastal city with strong mining and tech industries"
            },
            {
                name: "Adelaide",
                description: "Affordable city with excellent universities and quality of life"
            },
            {
                name: "Canberra",
                description: "Capital city with prestigious universities and government opportunities"
            },
            {
                name: "Gold Coast",
                description: "Coastal city with growing university presence and tourism industry"
            },
            {
                name: "Newcastle",
                description: "Industrial city with strong engineering and health programs"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 40 hours per fortnight during study periods and unlimited hours during scheduled breaks. Students typically earn AUD 18-25 per hour. The work experience gained can be valuable for future career prospects.",
        postStudyWork: "The Temporary Graduate visa (subclass 485) allows graduates to stay and work in Australia for 2-4 years depending on their qualification level. This visa provides an excellent pathway to gain Australian work experience and potentially qualify for permanent residency through various skilled migration programs."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in Australia?",
            answer: "To apply for a student visa, you need a Confirmation of Enrolment (CoE) from an Australian institution, proof of English proficiency, financial capacity, health insurance (OSHC), and a Genuine Temporary Entrant statement. The application is typically done online through ImmiAccount."
        },
        {
            question: "What are the English language requirements for studying in Australia?",
            answer: "Most Australian institutions require IELTS (6.0-7.0), TOEFL (60-100), PTE (50-65), or CAE (169-185) scores. Requirements vary by institution and program level."
        },
        {
            question: "Can I work while studying in Australia?",
            answer: "Yes, international students can work up to 40 hours per fortnight during study periods and unlimited hours during breaks. The Temporary Graduate visa allows graduates to work full-time after completing their studies."
        },
        {
            question: "Are scholarships available for international students in Australia?",
            answer: "Yes, there are various scholarships offered by the Australian government (Australia Awards), universities, and external organizations. These include merit-based, need-based, and country-specific scholarships."
        },
        {
            question: "How much does it cost to study in Australia from Bangladesh?",
            answer: "Studying in Australia from Bangladesh costs around AUD 20,000-50,000 for tuition, AUD 12,000-18,000 for living expenses, and AUD 500-600 for health insurance annually. Total annual cost ranges from AUD 32,000-68,000."
        },
        {
            question: "What GPA is required to study in Australia from Bangladesh?",
            answer: "To study in Australia from Bangladesh, the required GPA typically ranges from <strong>2.5 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.0 to 3.5</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
